import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { PAGE_TYPE, setPageTitle } from "containers/App/reducer";

import * as loginReducer from "containers/Login/reducer";
import * as accountsReducer from "containers/Accounts/reducer";

import AccountSettings from "components/AccountSettings/AccountSettings";

import SettingsViewContainer from "containers/View/SettingsView";

class AccountSettingsContainer extends React.PureComponent {
  componentDidMount() {
    setPageTitle(PAGE_TYPE.SETTINGS);
  }

  render() {
    return <AccountSettings {...this.props} view={<SettingsViewContainer />} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  checkRefresh: (options) => dispatch(loginReducer.checkRefresh(options))
});

const mapStateToProps = (state) => ({
  selectedTenant: loginReducer.getSelectedTenant(state),
  selectedAccount: accountsReducer.getSelectedAccount(state),
  accounts: accountsReducer.getAccounts(state),
  isLoading: accountsReducer.getIsLoading(state),
  isSampleAccount: loginReducer.getIsSampleAccount(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(AccountSettingsContainer);
